module.exports = __webpack_public_path__ + "static/media/express.c6bab64b.svg";